import { computed, inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { DeliveryFuncData } from '@interfaces';
import { AppService, FuncService, TrimesterService } from '../../services';

@Injectable({ providedIn: 'root' })
export class DeliveryAreaService {

	private func = inject(FuncService);
	private app = inject(AppService);
	private trimesterService = inject(TrimesterService);
	public readonly deliveryData = signal<DeliveryFuncData | undefined>(undefined);

	public selectedTrimesterName = computed(() => this.trimesterService.selectedTrimester()?.name);

	public staffPermissions = computed(() => this.app.data().permissions);

	constructor() {
		toObservable(this.trimesterService.selectedTrimester).subscribe(async (selectedTrimester) => {
			if (selectedTrimester) await this.reloadData();
		});
	}

	public async reloadData() {
		const trimesterId = this.trimesterService.selectedTrimester()?.trimesterId;
		//Should never happen, but just in case.
		//This is a safety check to ensure that the delivery data is only loaded when a trimester is selected.
		//If no trimester is selected, the delivery data will not be loaded
		//and the service will not be able to provide any data.
		if (trimesterId) {
			const data = await this.func.delivery.getData({ trimesterId });
			this.deliveryData.set(data);
		}
	}

	public async loadDeliveryData() {
		if (!this.deliveryData()) await this.reloadData();
	}

	async addEngagementIdToContactRequest(contactRequestId: number, engagementId: number) {
		await this.func.contactRequest.addEngagementId({ contactRequestId, engagementId });
	}
}